// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { CustomAppState } from "@tps/App/Store/Reducers";

export const TpsPopulateApiParameter: any = (props: any) => {
    const cartState = getCurrentCartState(props.getState());
    // XNG-Change: send PoNumber
    const poNumber = (props.getState() as CustomAppState)?.xCheckout?.poNumber || "";

    if (!cartState.value) {
        throw new Error("There was no current cart and we are trying to save the current cart.");
    }

    props.apiParameter = {
        cart: {
            ...cartState.value,
            // XNG-Change
            poNumber,
            status: "Saved",
        },
    };
};

replaceInChain(chain, PopulateApiParameter, TpsPopulateApiParameter);
